import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Contract } from 'src/app/lib/contract/classes';
import { IssueItem, Product } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';
import { WistaAMSTypes } from 'src/app/wista-ams-types';

@Component({
  selector: 'app-issue-item-label',
  templateUrl: './issue-item-label.component.html',
  styleUrls: ['./issue-item-label.component.css']
})
export class IssueItemLabelComponent implements OnDestroy, OnInit {

  contract: Contract;
  product: Product;

  _item: IssueItem;
  @Input() set item(item: IssueItem){
    this._item = item;
    if(item.itemcontract) this._dataService.resolve(WistaAMSTypes.Contract, item.itemcontract, (contract: Contract) => {
      this.contract = contract;
    }, true);
  }
  get item(): IssueItem {
    return this._item;
  }

  _subscriptions: Subscription[] = [];

  constructor(
    private _dataService: DataService,
    private _changeRef: ChangeDetectorRef
  ) {
    this._subscriptions.push(this._dataService.productsLoadedAnchor.subscribe(() => this.setProduct()));
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    if(this._dataService.allProductsLoaded) this.setProduct();
    else if(!this._dataService.allPrioritiesLoading) this._dataService.loadProducts();
  }

  setProduct(){
    if(this.item.itemproduct){
      this.product = this._dataService.products.find(x => x.productid === this.item.itemproduct);
    }
  }

}
